import { Component } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Route, Switch } from 'react-router-dom';
import { ToastContainer } from 'material-react-toastify';
import 'material-react-toastify/dist/ReactToastify.css';
import Status from './components/Status';
import Revoke from './components/Revoke';
import Login from './components/Login';
import Header from './components/common/Header';
import ConsentDetails from './components/ConsentDetails';
import EntitySelector from './components/EntitySelector';
import { UserProvider } from './context/UserContext';
import Footer from './components/common/Footer';
import FiuConsentDetails from './components/FiuConsentDetails';
const defaultConfig = {
	'fontFamily': 'Lato',
	'primaryColor': '#273C89',
	'secondaryColor': '#F5F5F5',
	'headingColor': '#191c1f',
	'subHeadingColor': '#0e65d7',
	'textColor': '#757779',
	'btnHeight': '40px',
	'btnWidth': '327px',
	'borderRadius': '8px',
	'fontSize': '12px',
	'primaryBtnColor': '#273C89',
	'btnBorderColor': '#ccc',
};
class App extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoader: false,
			configDetails: defaultConfig,
		};
	}
	updateLoader = (val) => {
		this.setState({ isLoader: val });
	};
	render() {
		return (
			<UserProvider>
				<div
					className="App"
					style={{ fontFamily: this.state.configDetails?.fontFamily }}
				>
					<Header customDetails={this.state.configDetails} />
					<Switch>
						<Route
							exact
							path="/"
							render={(props) => (
								<Login {...props} customDetails={this.state.configDetails} />
							)}
						/>

						<Route
							exact
							path="/fip"
							render={(props) => (
								<Login {...props} customDetails={this.state.configDetails} />
							)}
						/>
						<Route
							exact
							path="/revoke-consent"
							render={(props) => (
								<Revoke
									{...props}
									updateLoader={this.updateLoader}
									customDetails={this.state.configDetails}
								/>
							)}
						/>
						<Route
							exact
							path="/entity-selection"
							render={(props) => (
								<EntitySelector
									{...props}
									updateLoader={this.updateLoader}
									customDetails={this.state.configDetails}
								/>
							)}
						/>
						<Route
							exact
							path="/status"
							render={(props) => (
								<Status
									{...props}
									updateLoader={this.updateLoader}
									customDetails={this.state.configDetails}
								/>
							)}
						/>
						<Route
							exact
							path="/consent-details"
							render={(props) => (
								<ConsentDetails
									{...props}
									updateLoader={this.updateLoader}
									customDetails={this.state.configDetails}
								/>
							)}
						/>
						<Route
							exact
							path="/fiu-consent-details"
							render={(props) => (
								<FiuConsentDetails
									{...props}
									updateLoader={this.updateLoader}
									customDetails={this.state.configDetails}
								/>
							)}
						/>
					</Switch>
					<Footer customDetails={this.state.configDetails} />
					{/* To display Success, Warning or Error messages to user */}
					<div className="toast-message">
						<ToastContainer />
					</div>
					{/* To display API call Loader */}
					{this.state.isLoader ? (
						<div>
							<div className="application-loading-container">
								<div className="snippet" data-title=".dot-pulse">
									<div className="stage">
										<div className="dot-pulse-btn"></div>
									</div>
								</div>
								{/* <img className="image" src={LoaderImage} alt="" width="120" height="120"></img> */}
							</div>
						</div>
					) : null}
				</div>
			</UserProvider>
		);
	}
}

export default App;
